<template>
    <div
        class="h-screen w-screen pos-fixed bg-white pos-top pos-left overflow-auto z-max"
        :key="title"
        style="z-index: 99"
    >
        <div class="book-contents" style="padding: 7rem 0 6rem">
            <div
                class="pos-fixed pos-top pos-left w-screen bg-white shadow-3 d-flex flex-align-center z-1"
                style="height: 5rem"
            >
                <div
                    class="text-size-2 py-2 px-2 ml pos-absolute pos-left pos-center-y cursor-pointer"
                    style="width: 3rem; height: 3rem; flex: 0 0 3rem"
                    @click="$emit('close')"
                >
                    <p class="pos-absolute pos-center my-0">
                        <i class="icon-cr icon-chevron-left" />
                    </p>
                </div>
                <div class="flex-item-grow">
                    <div
                        :class="{
                            'medium-content': !large,
                            'large-content': large,
                        }"
                        style="padding-left: 4rem"
                        :style="{ paddingRight: large ? '4rem' : null }"
                    >
                        <h2 class="my-0">{{ title }}</h2>
                    </div>
                </div>
            </div>
            <div
                :class="{ 'medium-content': !large, 'large-content': large }"
                style="padding-left: 4rem"
                :style="{ paddingRight: large ? '4rem' : null }"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BrandBookSectionContents',
        props: {
            title: {
                type: String,
                required: true,
            },
            large: Boolean,
        },
    };
</script>
